/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiDataFromJSON, ApiDataToJSON, } from './ApiData';
import { ApiDomainFromJSON, ApiDomainToJSON, } from './ApiDomain';
import { ApiJobFromJSON, ApiJobToJSON, } from './ApiJob';
import { ApiLocationFromJSON, ApiLocationToJSON, } from './ApiLocation';
import { ApiPageStatusFromJSON, ApiPageStatusToJSON, } from './ApiPageStatus';
import { ApiPageTagFromJSON, ApiPageTagToJSON, } from './ApiPageTag';
import { ApiProductFromJSON, ApiProductToJSON, } from './ApiProduct';
import { ApiProjectFromJSON, ApiProjectToJSON, } from './ApiProject';
export function ApiPageFromJSON(json) {
    return ApiPageFromJSONTyped(json, false);
}
export function ApiPageFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'analyticsSynced': !exists(json, 'analyticsSynced') ? undefined : json['analyticsSynced'],
        'crawledAt': !exists(json, 'crawledAt') ? undefined : (new Date(json['crawledAt'])),
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'displayPage': !exists(json, 'displayPage') ? undefined : json['displayPage'],
        'domain': !exists(json, 'domain') ? undefined : ApiDomainFromJSON(json['domain']),
        'domainId': !exists(json, 'domainId') ? undefined : json['domainId'],
        'errorCounter': !exists(json, 'errorCounter') ? undefined : json['errorCounter'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'jobs': !exists(json, 'jobs') ? undefined : (json['jobs'].map(ApiJobFromJSON)),
        'lastActivityAt': !exists(json, 'lastActivityAt') ? undefined : (new Date(json['lastActivityAt'])),
        'locatedAt': !exists(json, 'locatedAt') ? undefined : (new Date(json['locatedAt'])),
        'locations': !exists(json, 'locations') ? undefined : (json['locations'].map(ApiLocationFromJSON)),
        'page': !exists(json, 'page') ? undefined : json['page'],
        'pageViews': !exists(json, 'pageViews') ? undefined : (json['pageViews'].map(ApiDataFromJSON)),
        'products': !exists(json, 'products') ? undefined : (json['products'].map(ApiProductFromJSON)),
        'project': !exists(json, 'project') ? undefined : ApiProjectFromJSON(json['project']),
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'status': !exists(json, 'status') ? undefined : ApiPageStatusFromJSON(json['status']),
        'statusCode': !exists(json, 'statusCode') ? undefined : json['statusCode'],
        'tags': !exists(json, 'tags') ? undefined : (json['tags'].map(ApiPageTagFromJSON)),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
    };
}
export function ApiPageToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'analyticsSynced': value.analyticsSynced,
        'crawledAt': value.crawledAt === undefined ? undefined : (value.crawledAt.toISOString()),
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'displayPage': value.displayPage,
        'domain': ApiDomainToJSON(value.domain),
        'domainId': value.domainId,
        'errorCounter': value.errorCounter,
        'id': value.id,
        'jobs': value.jobs === undefined ? undefined : (value.jobs.map(ApiJobToJSON)),
        'lastActivityAt': value.lastActivityAt === undefined ? undefined : (value.lastActivityAt.toISOString()),
        'locatedAt': value.locatedAt === undefined ? undefined : (value.locatedAt.toISOString()),
        'locations': value.locations === undefined ? undefined : (value.locations.map(ApiLocationToJSON)),
        'page': value.page,
        'pageViews': value.pageViews === undefined ? undefined : (value.pageViews.map(ApiDataToJSON)),
        'products': value.products === undefined ? undefined : (value.products.map(ApiProductToJSON)),
        'project': ApiProjectToJSON(value.project),
        'projectId': value.projectId,
        'status': ApiPageStatusToJSON(value.status),
        'statusCode': value.statusCode,
        'tags': value.tags === undefined ? undefined : (value.tags.map(ApiPageTagToJSON)),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
    };
}
